import { useCallback } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { Button, Post } from '@asset-metrix/portal-ui';

import { useStore } from '../../store';
import { extractErrorMessage } from '../../utils/errorMessage';

import { FullScreenFrame } from './FullScreenFrame';

import styles from './fullscreenerror.module.scss';

export function FullScreenError({ error }: { error: unknown }) {
  const { resetBoundary } = useErrorBoundary();
  const { t } = useTranslation();
  const logoutSession = useStore((state) => state.logoutSession);

  const logout = useCallback(async () => {
    resetBoundary();
    await logoutSession({ initiatedByUser: true });
  }, [logoutSession, resetBoundary]);

  return (
    <FullScreenFrame>
      <Post>
        <h1>Loading error</h1>
        <p>{extractErrorMessage(error, t('app.page.genericError'))}</p>
        <p data-right className={styles['button-container']}>
          <Button onClick={() => resetBoundary()}>{t('app.page.retry')}</Button>
          <Button variant="secondary" onClick={() => logout()}>
            {t('app.noAccessError.logoutButton')}
          </Button>
        </p>
      </Post>
    </FullScreenFrame>
  );
}
